import {SequenceModel, SequenceStatusesEnum} from '../../models/api/sequenceModel';

export function getVariablesForSequence(sequence: SequenceModel) {
  const fromFields = sequence.fields.map((field) => `sequence.${field}`);
  return ['sequence.email', ...fromFields];
}

export function isSequenceDraft(sequence: SequenceModel) {
  return sequence.status === SequenceStatusesEnum.DRAFT;
}
